import FBtnMDP from "@/components/FBtnMDP";
import { FFormChildMDP } from "@/components/form/FFormDrawerMDP";
import FFormMDP from "@/components/form/FFormMDP";
import FEmailFieldMDP from "@/components/form/field/FEmailFieldMDP";
import FPhoneFieldMDP from "@/components/form/field/FPhoneFieldMDP";
import FTextFieldMDP from "@/components/form/field/FTextFieldMDP";


export default class ClientDetailsFFormMDP extends FFormMDP {
  childMDP = new FFormChildMDP();
  root: any;
  // parent: any;
  constructor({ root }: { root: any }) {
    super({
      myRefName: "createClientFFormRef",
    });
    this.root = root;
    // this.parent = parent;

    this.addField(
      new FTextFieldMDP({
        parentMDP: this.childMDP,
        dataSelectorKey: "clientId",
        label: "Client Id",
        mandatory: true,
        boundaryClass: "col-4",
        disabled: true,
      })
    )
      .addField(
        new FTextFieldMDP({
          parentMDP: this.childMDP,
          dataSelectorKey: "firstName",
          label: "First Name",
          boundaryClass: "col-4",
          mandatory: true,
          disabled: true,
        })
      )
      .addField(
        new FTextFieldMDP({
          parentMDP: this.childMDP,
          dataSelectorKey: "lastName",
          label: "Last Name",
          boundaryClass: "col-4",
          mandatory: true,
          disabled: true,
        })
      )
      .addField(
        new FEmailFieldMDP({
          parentMDP: this.childMDP,
          dataSelectorKey: "emailId",
          label: "Email",
          boundaryClass: "col-4",
          mandatory: true,
          disabled: true,
        })
      )
      .addField(
        new FPhoneFieldMDP({
          parentMDP: this.childMDP,
          dataSelectorKey: "mobile",
          label: "Mobile",
          boundaryClass: "col-4",
          mandatory: true,
          disabled: true,
        })
      )
      .addField(
        new FPhoneFieldMDP({
          parentMDP: this.childMDP,
          dataSelectorKey: "leadSource",
          label: "Lead Source",
          boundaryClass: "col-4",
          disabled: true,
        })
      )
      .addAction(
        new FBtnMDP({
          label: "Add A File",
          onClick: this.addClientFile(),
        })
      );
  }

  getMyRef(): any {
    return this.root.$refs[this.myRefName];
  }

  addClientFile() {
    return () => {
      this.root.addClientFile();
    };
  }
}
